(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4638],{

/***/ 66667:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channelPath]/content-direct/[categoryCode]/plan/[planCode]",
      function () {
        return __webpack_require__(44886);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CoverageItemTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15746);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60082);
/* harmony import */ var src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64615);
/* harmony import */ var src_utils_coverageItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9209);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_4__);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: 24px;\n  .sunday-component-collapse-header,\n  .sunday-component-collapse-header-collapsible-only {\n    border: 0px !important;\n    padding: 0px !important;\n  }\n  .sunday-component-collapse-header-text {\n    width: fit-content;\n    padding-right: 24px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  .sunday-component-collapse-header,\n  .sunday-component-collapse-header-collapsible-only {\n    border: 0px !important;\n    padding: 0px !important;\n    margin-bottom: 0;\n  }\n  .sunday-component-collapse-header-text {\n    width: 100%;\n  }\n  .sunday-component-collapse-header.sunday-component-collapse-header-collapsible-only {\n    justify-content: space-between;\n    flex-direction: row-reverse;\n    align-items: center;\n  }\n  .sunday-component-collapse-extra {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 16px 12px 16px 12px;\n  font-size: 21px;\n  color: ",
        ";\n  p,\n  ul {\n    margin-bottom: 0px;\n  }\n  li {\n    line-height: 24px;\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var Collapse = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Collapse).withConfig({
    componentId: "sc-309576f4-0"
})(_templateObject());
var GroupCollapse = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Collapse).withConfig({
    componentId: "sc-309576f4-1"
})(_templateObject1());
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-309576f4-2"
})(_templateObject2());
var AdditionalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-309576f4-3"
})(_templateObject3(), src_styles_globals__WEBPACK_IMPORTED_MODULE_7__/* .color.charcoal10 */ .$.charcoal10);
var CoverageItemTable = function(param) {
    var allCoverageItems = param.allCoverageItems, insurerPlanCode = param.insurerPlanCode, tablePrimaryColor = param.tablePrimaryColor, tableSecondaryColor = param.tableSecondaryColor;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("plan").t;
    var mapCoverageItem = function(coverage, coverageType, index) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            span: 24,
            style: {
                background: index % 2 === 0 ? tablePrimaryColor : tableSecondaryColor
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                gutter: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        span: 12,
                        style: {
                            borderRight: "1px solid #FFFFFF",
                            padding: "16px 11px 4px"
                        },
                        children: (coverage === null || coverage === void 0 ? void 0 : coverage.coverageItem.detail) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Collapse, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Panel, {
                                header: coverage === null || coverage === void 0 ? void 0 : coverage.coverageItem.displayName[locale],
                                children: coverage === null || coverage === void 0 ? void 0 : coverage.coverageItem.detail[locale]
                            }, coverage === null || coverage === void 0 ? void 0 : coverage.coverageItem.code)
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Title, {
                            level: 7,
                            "data-cy": "plan-coverage-detail.".concat(insurerPlanCode, ".").concat(coverageType, ".coverage.").concat(index + 1, ".display-name"),
                            children: coverage === null || coverage === void 0 ? void 0 : coverage.coverageItem.displayName[locale]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        span: 12,
                        style: {
                            borderLeft: "1px solid #FFFFFF",
                            padding: "16px 0px",
                            alignSelf: "center"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Body, {
                            "data-cy": "plan-coverage-detail.".concat(insurerPlanCode, ".").concat(coverageType, ".coverage.").concat(index + 1, ".value"),
                            level: 7,
                            style: {
                                textAlign: "center"
                            },
                            children: (0,src_utils_coverageItem__WEBPACK_IMPORTED_MODULE_9__/* .getCoverageValueByType */ .H)(coverage === null || coverage === void 0 ? void 0 : coverage.coverageItem.valueType, coverage.value, locale)
                        })
                    })
                ]
            })
        }, coverage === null || coverage === void 0 ? void 0 : coverage.coverageItem.code);
    };
    var mapGroupCoverages = function(coverages, coverageType) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GroupCollapse, {
            defaultActiveKey: coverages[0].coverageItem.type,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Panel, {
                style: {
                    width: "100%"
                },
                header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        span: 24,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Title, {
                            level: 5,
                            style: {
                                textAlign: "center",
                                margin: "16px 0px"
                            },
                            children: t("planCoverageDetail.groupHeader.".concat(coverages[0].coverageItem.type))
                        })
                    })
                }),
                children: coverages.map(function(coverage, groupIndex) {
                    return mapCoverageItem(coverage, coverageType, groupIndex);
                })
            }, coverages[0].coverageItem.type)
        });
    };
    var maincoverages = allCoverageItems.filter(function(item) {
        return item.coverageItem.type !== src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__/* .CoverageType.other */ .yl.other && item.coverageItem.type !== src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__/* .CoverageType.additional */ .yl.additional;
    });
    var otherCoverages = allCoverageItems.filter(function(item) {
        return item.coverageItem.type === src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__/* .CoverageType.other */ .yl.other;
    });
    var additionalDetails = allCoverageItems.filter(function(item) {
        return item.coverageItem.type === src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__/* .CoverageType.additional */ .yl.additional;
    });
    var groupedCoverages = maincoverages.reduce(function(prevCoverages, currentCoverage) {
        // case main coverage (no group)
        if (currentCoverage.coverageItem.type === src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__/* .CoverageType.main */ .yl.main) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(prevCoverages).concat([
                currentCoverage
            ]);
        }
        // case type same as previous group
        if (Array.isArray(prevCoverages[prevCoverages.length - 1]) && prevCoverages[prevCoverages.length - 1][0].coverageItem.type === currentCoverage.coverageItem.type) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(prevCoverages.slice(0, prevCoverages.length - 1)).concat([
                (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(prevCoverages[prevCoverages.length - 1]).concat([
                    currentCoverage, 
                ]), 
            ]);
        }
        // case new group
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(prevCoverages).concat([
            [
                currentCoverage
            ]
        ]);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        justify: "center",
        children: [
            groupedCoverages.map(function(groupedCoverage, index) {
                return Array.isArray(groupedCoverage) ? mapGroupCoverages(groupedCoverage, "main-benefit") : mapCoverageItem(groupedCoverage, "main-benefit", index);
            }),
            otherCoverages.length > 0 && mapGroupCoverages(otherCoverages, "other-benefit"),
            additionalDetails.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GroupCollapse, {
                defaultActiveKey: [
                    src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__/* .CoverageType.additional */ .yl.additional
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Panel, {
                    style: {
                        width: "100%"
                    },
                    header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            span: 24,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Title, {
                                level: 5,
                                style: {
                                    textAlign: "center",
                                    margin: "16px 0px"
                                },
                                children: t("planCoverageDetail.groupHeader.additional")
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdditionalContainer, {
                        style: {
                            background: tablePrimaryColor,
                            width: "100%"
                        },
                        children: additionalDetails.map(function(param) {
                            var value = param.value;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                dangerouslySetInnerHTML: {
                                    __html: value[locale]
                                },
                                style: {
                                    width: "100%"
                                }
                            });
                        })
                    })
                }, src_types_productCategory__WEBPACK_IMPORTED_MODULE_10__/* .CoverageType.additional */ .yl.additional)
            })
        ]
    });
};


/***/ }),

/***/ 29243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60082);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: fit-content;\n  background: ",
        ";\n  border-radius: 4px;\n  align-self: center;\n  margin: 0 8px 8px 0;\n  padding: 4px 8px 4px 8px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  word-break: break-all;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var LabelContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5ec5f76b-0"
})(_templateObject(), function(props) {
    return props.color || _styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.frenchBlueFb */ .$.frenchBlueFb;
}, function(props) {
    return props.margin ? "margin: ".concat(props.margin) : "";
}, function(props) {
    return props.margin ? "margin: ".concat(props.margin) : "";
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Title).withConfig({
    componentId: "sc-5ec5f76b-1"
})(_templateObject1(), function(props) {
    return props.color || _styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.white */ .$.white;
});
var LabelBox = function(param) {
    var label = param.label, textColor = param.textColor, backgroundColor = param.backgroundColor, margin = param.margin;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LabelContainer, {
        label: label,
        margin: margin,
        color: backgroundColor,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
            level: 10,
            color: textColor,
            children: label
        })
    });
};
LabelBox.defaultProps = {
    textColor: _styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.white */ .$.white,
    backgroundColor: _styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.frenchBlueFb */ .$.frenchBlueFb
};
/* harmony default export */ __webpack_exports__["Z"] = (LabelBox);


/***/ }),

/***/ 44886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _planCode_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(66934);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./src/api/plan.ts
var api_plan = __webpack_require__(76922);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(63197);
// EXTERNAL MODULE: ./src/utils/logger.ts + 1 modules
var logger = __webpack_require__(14744);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/constants/params.ts
var params = __webpack_require__(62090);
// EXTERNAL MODULE: ./src/constants/format.ts
var format = __webpack_require__(71512);
// EXTERNAL MODULE: ./src/api/droplead.ts
var droplead = __webpack_require__(26451);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/constants/logicalGroupChannelCode.ts
var logicalGroupChannelCode = __webpack_require__(85760);
// EXTERNAL MODULE: ./src/utils/cookies.ts
var cookies = __webpack_require__(41074);
// EXTERNAL MODULE: ./src/components/EntryForm/EntryFormBanner.tsx
var EntryFormBanner = __webpack_require__(35342);
// EXTERNAL MODULE: ./src/components/PlanContentDirectLinkPage/ProductList.tsx
var ProductList = __webpack_require__(98310);
// EXTERNAL MODULE: ./src/components/EntryForm/EntryFormModal.tsx
var EntryFormModal = __webpack_require__(95040);
// EXTERNAL MODULE: ./src/utils/currency.ts
var currency = __webpack_require__(82833);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./src/constants/template.ts
var constants_template = __webpack_require__(61956);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Common/CoverageItemTable.tsx
var CoverageItemTable = __webpack_require__(84527);
;// CONCATENATED MODULE: ./src/components/PlanContentDirectLinkPage/CoverageTableSection.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 48px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: -webkit-fill-available;\n  }\n  max-height: 48px;\n  width: 330px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var CoverageTableSection_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-3b46d252-0"
})(_templateObject());
var ButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-3b46d252-1"
})(_templateObject1(), (0,styled_breakpoints.down)("sm"));
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b46d252-2"
})(_templateObject2());
var CoverageTableSection = function(param) {
    var allCoverageItems = param.allCoverageItems, insurerPlanCode = param.insurerPlanCode, policyDetailUrl = param.policyDetailUrl, tablePrimaryColor = param.tablePrimaryColor, tableSecondaryColor = param.tableSecondaryColor;
    var t = (0,esm/* useTranslation */.$G)("plan").t;
    var locale = (0,next_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                    level: 1,
                    children: t("planCoverageDetail.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverageItemTable/* CoverageItemTable */.m, {
                allCoverageItems: allCoverageItems,
                insurerPlanCode: insurerPlanCode,
                tablePrimaryColor: tablePrimaryColor,
                tableSecondaryColor: tableSecondaryColor
            }),
            policyDetailUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: policyDetailUrl[locale],
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverageTableSection_Button, {
                            fullWidth: true,
                            "data-testid": "download-policy-button",
                            "data-gtm-input-code": "download-policy-button",
                            "data-cy": "plan-coverage-detail.".concat(insurerPlanCode, ".detail-button"),
                            type: "outlined",
                            block: true,
                            children: t("planCoverageDetail.download")
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/PlanContentDirectLinkPage/SpecialBenefitSection.tsx
var SpecialBenefitSection = __webpack_require__(25194);
// EXTERNAL MODULE: ./src/components/Common/Label.tsx
var Label = __webpack_require__(29243);
;// CONCATENATED MODULE: ./src/components/PlanContentDirectLinkPage/PlanContentDirectLinkDetail.tsx



function PlanContentDirectLinkDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  padding: 16px;\n  margin: 0px auto 40px auto;\n\n  border: 1px solid ",
        ";\n  border-radius: 16px;\n  max-width: 938px;\n\n  ",
        " {\n    border: 0px;\n    padding: 0px 16px 16px 16px;\n  }\n"
    ]);
    PlanContentDirectLinkDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlanContentDirectLinkDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PlanContentDirectLinkDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PlanContentDirectLinkDetail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2px;\n"
    ]);
    PlanContentDirectLinkDetail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: block;\n  height: 40px;\n  width: 40px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--ui-form-plans_card-price-text-color);\n  text-align: center;\n  margin: 0px 0px 0px 2px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  margin: 24px 0px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: left;\n  margin: 24px 0px;\n  margin-left: auto;\n  margin-right: auto;\n  width: fit-content;\n  line-height: 1.25;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px !important;\n  width: 100px !important;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 21px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  ",
        " {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}















var PlanContentDirectLinkDetail_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bb29bfd-0"
})(PlanContentDirectLinkDetail_templateObject(), globals/* color.charcoal03 */.$.charcoal03, (0,styled_breakpoints.down)("md"));
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bb29bfd-1"
})(PlanContentDirectLinkDetail_templateObject1());
var InsurerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bb29bfd-2"
})(PlanContentDirectLinkDetail_templateObject2());
var LogoImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3bb29bfd-3"
})(_templateObject3());
var InsurerTitleText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-3bb29bfd-4"
})(_templateObject4(), globals/* color.charcoal09 */.$.charcoal09);
var PlanTitleText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-3bb29bfd-5"
})(_templateObject5(), globals/* color.charcoal10 */.$.charcoal10);
var PriceText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-3bb29bfd-6"
})(_templateObject6());
var PriceInlineText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-3bb29bfd-7"
})(_templateObject7(), globals/* color.charcoal09 */.$.charcoal09);
var PlanDescriptionTextA = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-3bb29bfd-8"
})(_templateObject8(), globals/* color.charcoal10 */.$.charcoal10);
var PlanDescriptionTextB = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-3bb29bfd-9"
})(_templateObject9(), globals/* color.charcoal10 */.$.charcoal10);
var RemarkText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-3bb29bfd-10"
})(_templateObject10(), globals/* color.warningYellow03 */.$.warningYellow03);
var PriceSkeletonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bb29bfd-11"
})(_templateObject11());
var PriceSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-3bb29bfd-12"
})(_templateObject12());
var ButtonText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-3bb29bfd-13"
})(_templateObject13());
var PlanContentDirectLinkDetail_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-3bb29bfd-14"
})(_templateObject14());
var ButtonSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bb29bfd-15"
})(_templateObject15(), function(props) {
    return props.maxWidth;
}, (0,styled_breakpoints.down)("md"));
var RemarkTextSection = function(param) {
    var isMatchedPricingItem = param.isMatchedPricingItem, remarkPriceEspeciallyForYou = param.remarkPriceEspeciallyForYou, remarkPriceDependingOnInsured = param.remarkPriceDependingOnInsured;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RemarkText, {
        level: 10,
        children: isMatchedPricingItem ? remarkPriceEspeciallyForYou : remarkPriceDependingOnInsured
    });
};
var PriceTextSection = function(param) {
    var isMatchedPricingItem = param.isMatchedPricingItem, isPriceLoading = param.isPriceLoading, price = param.price, priceStarter = param.priceStarter, coveragePeriod = param.coveragePeriod;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceText, {
            level: 4,
            children: [
                !isMatchedPricingItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceInlineText, {
                            level: 9,
                            children: priceStarter
                        }),
                        " "
                    ]
                }),
                isPriceLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeletonSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeleton, {
                        active: true,
                        size: "small"
                    })
                }) : "".concat((0,currency/* numberToCurrency */.fe)(+price), "*"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceInlineText, {
                    level: 9,
                    children: coveragePeriod
                })
            ]
        })
    });
};
var HeaderButtonSection = function(param) {
    var isMatchedPricingItem = param.isMatchedPricingItem, onOpenEntryForm = param.onOpenEntryForm, reCalculatePriceButtonText = param.reCalculatePriceButtonText, handleGoToAppForm = param.handleGoToAppForm, isGoToAppFormLoading = param.isGoToAppFormLoading, buyThisPlanButtonText = param.buyThisPlanButtonText, calculatePriceButtonText = param.calculatePriceButtonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSectionContainer, {
        maxWidth: isMatchedPricingItem ? "646px" : "330px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
            justify: "center",
            gutter: [
                24,
                16
            ],
            children: isMatchedPricingItem ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        lg: {
                            span: 12,
                            order: 1
                        },
                        sm: {
                            span: 24,
                            order: 2
                        },
                        xs: {
                            span: 24,
                            order: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanContentDirectLinkDetail_Button, {
                            "data-testid": "re-calculate-price-button",
                            "data-gtm-input-code": "re-calculate-price-button",
                            type: "outlined",
                            onClick: onOpenEntryForm,
                            fullWidth: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                                level: 7,
                                children: reCalculatePriceButtonText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        lg: {
                            span: 12,
                            order: 2
                        },
                        sm: {
                            span: 24,
                            order: 1
                        },
                        xs: {
                            span: 24,
                            order: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanContentDirectLinkDetail_Button, {
                            "data-testid": "buy-this-plan-button",
                            "data-gtm-input-code": "buy-this-plan-button",
                            onClick: handleGoToAppForm,
                            fullWidth: true,
                            loading: isGoToAppFormLoading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                                level: 7,
                                children: buyThisPlanButtonText
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanContentDirectLinkDetail_Button, {
                    "data-testid": "calculate-price-button",
                    "data-gtm-input-code": "calculate-price-button",
                    fullWidth: true,
                    onClick: onOpenEntryForm,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                        level: 7,
                        children: calculatePriceButtonText
                    })
                })
            })
        })
    });
};
var PlanContentDirectLinkDetail = function(param) {
    var insurer = param.insurer, product = param.product, plan = param.plan, price = param.price, insurerPlanCode = param.insurerPlanCode, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, allCoverageItems = param.allCoverageItems, specialBenefitItems = param.specialBenefitItems, isPriceLoading = param.isPriceLoading, isMatchedPricingItem = param.isMatchedPricingItem, _onOpenEntryForm = param.onOpenEntryForm, onOpenEntryForm = _onOpenEntryForm === void 0 ? function() {} : _onOpenEntryForm, _onGoToAppForm = param.onGoToAppForm, onGoToAppForm = _onGoToAppForm === void 0 ? function() {} : _onGoToAppForm, CoverageTablePrimaryColor = param.CoverageTablePrimaryColor, CoverageTableSecondaryColor = param.CoverageTableSecondaryColor, _template = param.template, template = _template === void 0 ? constants_template/* COVERAGE_DETAIL_TEMPLATE_OPTION.A */.C.A : _template;
    var locale = (0,next_router.useRouter)().locale;
    var t = (0,esm/* useTranslation */.$G)([
        "plan-page",
        "plan-content-direct-link"
    ]).t;
    var ref = (0,react.useState)(false), isGoToAppFormLoading = ref[0], setIsGoToAppFormLoading = ref[1];
    var handleGoToAppForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsGoToAppFormLoading(true);
                        return [
                            4,
                            onGoToAppForm()
                        ];
                    case 1:
                        _state.sent();
                        setIsGoToAppFormLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGoToAppForm() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlanContentDirectLinkDetail_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                children: [
                    labels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        justify: "center",
                        children: labels.map(function(label) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                label: label.displayName[locale],
                                textColor: label.colorCode.text,
                                backgroundColor: label.colorCode.background
                            }, label.displayName.en);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsurerContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoImg, {
                                src: insurer.logo.url
                            }, insurer.logo.code),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsurerTitleText, {
                                level: 9,
                                children: insurer.displayName[locale]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanTitleText, {
                        level: 7,
                        children: product.displayName[locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanTitleText, {
                        level: 7,
                        children: plan.displayName[locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTextSection, {
                        isMatchedPricingItem: isMatchedPricingItem,
                        isPriceLoading: isPriceLoading,
                        price: price,
                        priceStarter: t("planDetail.priceStarter", {
                            ns: "plan-content-direct-link"
                        }),
                        coveragePeriod: plan.coveragePeriod ? t("coverageDetail.coveragePeriod.".concat(plan.coveragePeriod), {
                            ns: "plan-page"
                        }) : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RemarkTextSection, {
                        isMatchedPricingItem: isMatchedPricingItem,
                        remarkPriceEspeciallyForYou: t("planDetail.remarkPriceEspeciallyForYou", {
                            ns: "plan-content-direct-link"
                        }),
                        remarkPriceDependingOnInsured: t("planDetail.remarkPriceDependingOnInsured", {
                            ns: "plan-content-direct-link"
                        })
                    }),
                    template === constants_template/* COVERAGE_DETAIL_TEMPLATE_OPTION.A */.C.A && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanDescriptionTextA, {
                        level: 7,
                        children: plan.description[locale]
                    }),
                    template === constants_template/* COVERAGE_DETAIL_TEMPLATE_OPTION.B */.C.B && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanDescriptionTextB, {
                        level: 7,
                        children: plan.description[locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderButtonSection, {
                        isMatchedPricingItem: isMatchedPricingItem,
                        onOpenEntryForm: onOpenEntryForm,
                        reCalculatePriceButtonText: t("planDetail.reCalculatePriceButton", {
                            ns: "plan-content-direct-link"
                        }),
                        handleGoToAppForm: handleGoToAppForm,
                        isGoToAppFormLoading: isGoToAppFormLoading,
                        buyThisPlanButtonText: t("planDetail.buyThisPlanButton", {
                            ns: "plan-content-direct-link"
                        }),
                        calculatePriceButtonText: t("planDetail.calculatePriceButton", {
                            ns: "plan-content-direct-link"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverageTableSection, {
                allCoverageItems: allCoverageItems,
                insurerPlanCode: insurerPlanCode,
                policyDetailUrl: plan.policyDetailUrl,
                tablePrimaryColor: CoverageTablePrimaryColor,
                tableSecondaryColor: CoverageTableSecondaryColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialBenefitSection/* SpecialBenefitSection */.p, {
                specialBenefitItems: specialBenefitItems,
                insurerPlanCode: insurerPlanCode
            })
        ]
    });
};
/* harmony default export */ var PlanContentDirectLinkPage_PlanContentDirectLinkDetail = (PlanContentDirectLinkDetail);

// EXTERNAL MODULE: ./src/components/PlanContentDirectLinkPage/OtherPlanBanner.tsx + 1 modules
var OtherPlanBanner = __webpack_require__(53883);
// EXTERNAL MODULE: ./src/components/Common/ErrorDialog.tsx
var ErrorDialog = __webpack_require__(87418);
// EXTERNAL MODULE: ./src/components/PlanContentDirectLinkPage/NotFoundDirectLinkError/NotFoundDirectLinkError.tsx + 1 modules
var NotFoundDirectLinkError = __webpack_require__(20206);
;// CONCATENATED MODULE: ./src/components/PlanContentDirectLinkPage/index.tsx






function PlanContentDirectLinkPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  margin: 0px 0px 40px 0px;\n"
    ]);
    PlanContentDirectLinkPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlanContentDirectLinkPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  margin: 40px auto 24px auto;\n"
    ]);
    PlanContentDirectLinkPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PlanContentDirectLinkPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  margin: 24px auto;\n"
    ]);
    PlanContentDirectLinkPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PlanContentDirectLinkPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  line-height: 110%;\n  margin: 0px 16px;\n"
    ]);
    PlanContentDirectLinkPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PlanContentDirectLinkPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 24px auto;\n  padding: 0px 16px;\n  text-align: center;\n  max-width: 476px;\n  ",
        " {\n    max-width: 375px;\n  }\n"
    ]);
    PlanContentDirectLinkPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


























var PlanContentDirectLinkPage_RemarkText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-e760710e-0"
})(PlanContentDirectLinkPage_templateObject(), globals/* color.charcoal08 */.$.charcoal08);
var TitleDesktop = (0,styled_components_browser_esm/* default */.ZP)(lib.Hero).withConfig({
    componentId: "sc-e760710e-1"
})(PlanContentDirectLinkPage_templateObject1(), globals/* color.charcoal10 */.$.charcoal10);
var TitleMobile = (0,styled_components_browser_esm/* default */.ZP)(lib.Headline).withConfig({
    componentId: "sc-e760710e-2"
})(PlanContentDirectLinkPage_templateObject2(), globals/* color.charcoal10 */.$.charcoal10);
var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-e760710e-3"
})(PlanContentDirectLinkPage_templateObject3(), globals/* color.charcoal10 */.$.charcoal10);
var TitleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e760710e-4"
})(PlanContentDirectLinkPage_templateObject4(), (0,styled_breakpoints.down)("lg"));
var PlanContentDirectLinkPage_RemarkTextSection = function(param) {
    var remark = param.remark;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanContentDirectLinkPage_RemarkText, {
        level: 8,
        children: remark
    });
};
var PlanContentDirectLinkPage = function(param) {
    var channelPath = param.channelPath, channelConfig = param.channelConfig, plan = param.plan, starterPrice = param.starterPrice, productCategory = param.productCategory, banner = param.banner, productCategoryActiveList = param.productCategoryActiveList;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var content = channelConfig.content;
    var productCategories = productCategoryActiveList.map(function(product) {
        return (0,_object_spread/* default */.Z)({}, product);
    }).sort(function(a, b) {
        return a.seq - b.seq;
    });
    var isRET = channelConfig.logicalGroupChannelCode === logicalGroupChannelCode/* RETAIL_LOGICAL_GROUP_CHANNEL_CODE */.b;
    var t = (0,esm/* useTranslation */.$G)([
        "plan-content-direct-link",
        "entry-form"
    ]).t;
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    var ref31 = (0,react.useState)(false), isPriceLoading = ref31[0], setIsPriceLoading = ref31[1];
    var ref32 = (0,react.useState)(false), isVisible = ref32[0], setIsVisible = ref32[1];
    var ref33 = (0,react.useState)(false), isMatchedPricingItem = ref33[0], setIsMatchedPricingItem = ref33[1];
    var ref34 = (0,react.useState)(starterPrice.price), price = ref34[0], setPrice = ref34[1];
    var ref35 = (0,react.useState)(starterPrice.insurerPlanCode), insurerPlanCode = ref35[0], setInsurerPlanCode = ref35[1];
    var ref36 = (0,react.useState)(null), entryFormInput = ref36[0], setEntryFormInput = ref36[1];
    var ref37 = (0,react.useState)(false), isTechnicalErrorDialogVisible = ref37[0], setIsTechnicalErrorDialogVisible = ref37[1];
    var ref38 = (0,react.useState)(false), isError = ref38[0], setIsError = ref38[1];
    var onOpenModal = function() {
        setIsVisible(true);
    };
    var onGoToPlanPage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var entryFormPageUrl, query;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        entryFormPageUrl = (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/").concat(productCategory.code, "/plan"));
                        query = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_), Object.fromEntries(Object.entries(entryFormInput).filter(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], input = _param[1];
                            return input !== null && input !== void 0 ? input : false;
                        }))), {
                            channelPath: channelPath,
                            categoryCode: productCategory.code
                        });
                        return [
                            4,
                            router.push({
                                pathname: entryFormPageUrl,
                                query: query
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onGoToPlanPage() {
            return _ref.apply(this, arguments);
        };
    }();
    var onEntryFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, matchedPricingItem, utmObj, sRefCode, ref1, req, queryString, error, isUnknownError, ref2, utmObj1, sRefCode1, ref3, req1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            9,
                            10
                        ]);
                        setIsPriceLoading(true);
                        setEntryFormInput(values);
                        return [
                            4,
                            (0,api_plan/* getPlanMatchedPricingItem */.gl)(plan.code, productCategory.code, channelConfig.code, values)
                        ];
                    case 1:
                        matchedPricingItem = _state.sent();
                        utmObj = (0,cookies/* utmCheckout */.T3)(channelPath);
                        sRefCode = (ref = router.query) === null || ref === void 0 ? void 0 : ref.sRefCode;
                        if (!(values === null || values === void 0 ? void 0 : values.leadRequest)) return [
                            3,
                            3
                        ];
                        req = {
                            type: "plan-direct-link",
                            channelCode: channelConfig.code,
                            body: {
                                planName: plan.displayName.th,
                                productName: plan.product.displayName.th,
                                planCode: plan.code,
                                productCode: plan.product.code,
                                productType: plan.product.productType,
                                channelUrl: "".concat(window.location.protocol, "//").concat(window.location.hostname, "/").concat(channelPath),
                                contentDirectLinkUrl: "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(window.location.pathname),
                                price: matchedPricingItem.price,
                                fullName: values.fullName,
                                categoryCode: productCategory.code,
                                mobileNumber: values.mobileNumber,
                                sRefCode: sRefCode,
                                utmCampaign: utmObj.utmCampaign,
                                utmMedium: utmObj.utmMedium,
                                utmSource: utmObj.utmSource,
                                entryForm: {
                                    code: (ref1 = productCategory.entryForm) === null || ref1 === void 0 ? void 0 : ref1.code,
                                    input: {
                                        insuredDateOfBirth: values.insuredDateOfBirth,
                                        effectiveDate: values.effectiveDate
                                    }
                                }
                            }
                        };
                        return [
                            4,
                            (0,droplead/* submitDirectLinkDropLead */.b)(req)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        queryString = (0,_object_spread/* default */.Z)({}, (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_), Object.fromEntries(Object.entries({
                            insuredDateOfBirth: values.insuredDateOfBirth,
                            effectiveDate: values.effectiveDate
                        }).filter(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], input = _param[1];
                            return input != null;
                        })));
                        router.push({
                            pathname: window.location.pathname,
                            query: queryString
                        }, undefined, {
                            shallow: true
                        });
                        setPrice(matchedPricingItem.price);
                        setInsurerPlanCode(matchedPricingItem.insurerPlanCode);
                        setIsMatchedPricingItem(true);
                        setIsError(false);
                        return [
                            3,
                            10
                        ];
                    case 4:
                        error = _state.sent();
                        isUnknownError = (0,errors/* checkUnknownError */.t)(error);
                        if (!isUnknownError) return [
                            3,
                            5
                        ];
                        (0,logger/* logError */.H)("Plan content direct page error by get matched pricing item error", {
                            planCode: plan.code,
                            categoryCode: productCategory.code,
                            channelCode: channelConfig.code,
                            entryFormInput: values
                        }, error);
                        setIsTechnicalErrorDialogVisible(true);
                        return [
                            3,
                            8
                        ];
                    case 5:
                        setIsError(true);
                        setPrice(starterPrice.price);
                        setIsMatchedPricingItem(false);
                        utmObj1 = (0,cookies/* utmCheckout */.T3)(channelPath);
                        sRefCode1 = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.sRefCode;
                        if (!(values === null || values === void 0 ? void 0 : values.leadRequest)) return [
                            3,
                            7
                        ];
                        req1 = {
                            type: "plan-direct-link",
                            channelCode: channelConfig.code,
                            body: {
                                planName: plan.displayName.th,
                                productName: plan.product.displayName.th,
                                planCode: plan.code,
                                productCode: plan.product.code,
                                productType: plan.product.productType,
                                channelUrl: "".concat(window.location.protocol, "//").concat(window.location.hostname, "/").concat(channelPath),
                                contentDirectLinkUrl: "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(window.location.pathname),
                                fullName: values.fullName,
                                categoryCode: productCategory.code,
                                mobileNumber: values.mobileNumber,
                                sRefCode: sRefCode1,
                                utmCampaign: utmObj1.utmCampaign,
                                utmMedium: utmObj1.utmMedium,
                                utmSource: utmObj1.utmSource,
                                entryForm: {
                                    code: (ref3 = productCategory.entryForm) === null || ref3 === void 0 ? void 0 : ref3.code,
                                    input: {
                                        insuredDateOfBirth: values.insuredDateOfBirth,
                                        effectiveDate: values.effectiveDate
                                    }
                                },
                                additionalDetails: "อายุของลูกค้าไม่อยู่ในช่วงอายุของแผนที่เลือก"
                            }
                        };
                        return [
                            4,
                            (0,droplead/* submitDirectLinkDropLead */.b)(req1)
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        if (true) {
                            window.scrollTo({
                                top: 0,
                                behavior: "auto"
                            });
                        }
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setIsPriceLoading(false);
                        if (true) {
                            window.scrollTo({
                                top: 0,
                                behavior: "auto"
                            });
                        }
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function onEntryFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var onGoToAppFormPage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var appFormUrl, query;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        appFormUrl = (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/").concat(productCategory.code, "/plan/").concat(plan.code, "/application-form"));
                        query = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query, Object.fromEntries(Object.entries(entryFormInput).filter(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], input = _param[1];
                            return input !== null && input !== void 0 ? input : false;
                        }))), {
                            channelPath: channelPath,
                            categoryCode: productCategory.code
                        });
                        return [
                            4,
                            router.push({
                                pathname: appFormUrl,
                                query: query
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onGoToAppFormPage() {
            return _ref.apply(this, arguments);
        };
    }();
    var onGoToEntryFormPage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var entryFormPageUrl, query;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        entryFormPageUrl = (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/").concat(productCategory.code));
                        query = (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_);
                        return [
                            4,
                            router.push({
                                pathname: entryFormPageUrl,
                                query: query
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onGoToEntryFormPage() {
            return _ref.apply(this, arguments);
        };
    }();
    var onReloadPage = function() {
        router.reload();
    };
    var techinicalErrorDialogProps = {
        title: t("errorDialog.apiError.title"),
        description: t("errorDialog.apiError.description"),
        errorButtons: [
            {
                text: t("errorDialog.apiError.submitText"),
                onClick: onReloadPage
            }, 
        ]
    };
    var initEffectiveDate = router.query.effectiveDate ? typeof router.query.effectiveDate === "string" && dayjs_min_default()(router.query.effectiveDate, format/* DATE_INPUT_TEXT_FORMAT */.AV) : dayjs_min_default()().add(1, "days");
    var initInsuredDateOfBirth = router.query.insuredDateOfBirth ? typeof router.query.insuredDateOfBirth === "string" && dayjs_min_default()(router.query.insuredDateOfBirth, format/* DATE_INPUT_TEXT_FORMAT */.AV) : undefined;
    var initialValuesEntryForm = {
        effectiveDate: (initEffectiveDate === null || initEffectiveDate === void 0 ? void 0 : initEffectiveDate.isValid()) ? initEffectiveDate : null,
        insuredDateOfBirth: (initInsuredDateOfBirth === null || initInsuredDateOfBirth === void 0 ? void 0 : initInsuredDateOfBirth.isValid()) ? initInsuredDateOfBirth : null,
        insuredGender: router.query.insuredGender
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorDialog/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, techinicalErrorDialogProps), {
                isVisible: isTechnicalErrorDialogVisible
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryFormModal/* default */.Z, {
                titleText: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        "data-testid": "entry-form-modal-description",
                        "data-gtm-input-code": "entry-form-modal-description",
                        level: 7,
                        children: t("entry-form:form.description", {
                            ns: "entry-form"
                        })
                    })
                }),
                visible: isVisible,
                entryFormCode: (ref = productCategory.entryForm) === null || ref === void 0 ? void 0 : ref.code,
                activeInputCodes: (ref1 = productCategory.entryForm) === null || ref1 === void 0 ? void 0 : ref1.activeInputCodes,
                setVisible: setIsVisible,
                onSubmit: onEntryFormSubmit,
                leadEnabled: (ref2 = content.directlink) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.plan) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.dropLead) === null || ref4 === void 0 ? void 0 : ref4.enabled,
                leadDefaultSelected: (ref5 = content.directlink) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.plan) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.dropLead) === null || ref7 === void 0 ? void 0 : ref7.defaultSelected,
                initialValues: initialValuesEntryForm,
                isInitialValuesValidate: !!initialValuesEntryForm.effectiveDate && !!initialValuesEntryForm.insuredDateOfBirth
            }),
            isError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundDirectLinkError/* default */.Z, {
                channelPath: channelPath,
                onOpenEntryForm: onOpenModal,
                onGoToPlanPage: onGoToPlanPage
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryFormBanner["default"], {
                        title: banner.title,
                        desktopImage: banner.desktopImage,
                        mobileImage: banner.mobileImage,
                        content: content
                    }),
                    lg ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDesktop, {
                        level: 4,
                        children: content.directlink.plan.title[locale]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleMobile, {
                        level: 3,
                        children: content.directlink.plan.title[locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanContentDirectLinkPage_PlanContentDirectLinkDetail, {
                        insurer: plan.product.insurer,
                        product: plan.product,
                        plan: plan,
                        price: price,
                        insurerPlanCode: insurerPlanCode,
                        labels: plan.labels || [],
                        allCoverageItems: plan.allCoverageItems || [],
                        specialBenefitItems: plan.specialBenefitItems || [],
                        isPriceLoading: isPriceLoading,
                        isMatchedPricingItem: isMatchedPricingItem,
                        onOpenEntryForm: onOpenModal,
                        onGoToAppForm: onGoToAppFormPage,
                        CoverageTablePrimaryColor: (ref8 = content.plan) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.coverageTable) === null || ref9 === void 0 ? void 0 : ref9.primaryColor,
                        CoverageTableSecondaryColor: (ref10 = content.plan) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.coverageTable) === null || ref11 === void 0 ? void 0 : ref11.secondaryColor,
                        template: (ref12 = content.coverageDetail) === null || ref12 === void 0 ? void 0 : ref12.template
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanContentDirectLinkPage_RemarkTextSection, {
                        remark: t("remark", {
                            ns: "plan-content-direct-link"
                        })
                    }),
                    ((ref13 = content.directlink) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.othersInCategory) === null || ref14 === void 0 ? void 0 : ref14.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherPlanBanner/* default */.Z, {
                        title: (ref15 = content.directlink) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.othersInCategory) === null || ref16 === void 0 ? void 0 : ref16.title,
                        description: (ref17 = content.directlink) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.othersInCategory) === null || ref18 === void 0 ? void 0 : ref18.content,
                        imageUrl: (ref19 = content.directlink) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.othersInCategory) === null || ref20 === void 0 ? void 0 : ref20.imageUrl,
                        bgColor: (ref21 = content.directlink) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.othersInCategory) === null || ref22 === void 0 ? void 0 : ref22.background.color,
                        isFullSize: !((ref23 = content.directlink) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.otherCategories) === null || ref24 === void 0 ? void 0 : ref24.enabled),
                        onSeeOtherPlans: isMatchedPricingItem && entryFormInput ? onGoToPlanPage : onGoToEntryFormPage,
                        titleColor: (ref25 = content.directlink) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.othersInCategory) === null || ref26 === void 0 ? void 0 : ref26.titleTextColor,
                        contentColor: (ref27 = content.directlink) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.othersInCategory) === null || ref28 === void 0 ? void 0 : ref28.contentTextColor
                    })
                ]
            }),
            ((ref29 = content.directlink) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.otherCategories) === null || ref30 === void 0 ? void 0 : ref30.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                isLoading: false,
                productCategories: productCategories,
                channelPath: channelPath,
                content: content,
                isRET: isRET
            })
        ]
    });
};
/* harmony default export */ var components_PlanContentDirectLinkPage = (PlanContentDirectLinkPage);

// EXTERNAL MODULE: ./src/components/Layout/withLayout.tsx + 6 modules
var withLayout = __webpack_require__(20587);
// EXTERNAL MODULE: ./src/components/Auth/withUserOrGuest.tsx
var withUserOrGuest = __webpack_require__(94665);
;// CONCATENATED MODULE: ./src/pages/[channelPath]/content-direct/[categoryCode]/plan/[planCode]/index.tsx



var __N_SSP = true;
/* harmony default export */ var _planCode_ = ((0,withUserOrGuest/* default */.Z)((0,withLayout/* withLayout */.X)(components_PlanContentDirectLinkPage)));


/***/ }),

/***/ 9209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getCoverageValueByType; }
/* harmony export */ });
/* harmony import */ var src_types_productCategory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64615);
/* harmony import */ var _currency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82833);


/* eslint-disable import/prefer-default-export */ var getCoverageValueByType = function(type, value) {
    var locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en";
    if (type === src_types_productCategory__WEBPACK_IMPORTED_MODULE_0__/* .ValueType.number */ .Ge.number) {
        return (0,_currency__WEBPACK_IMPORTED_MODULE_1__/* .numberToCurrency */ .fe)(+value);
    }
    if (type === src_types_productCategory__WEBPACK_IMPORTED_MODULE_0__/* .ValueType.string */ .Ge.string) {
        return value[locale];
    }
    return "";
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,4456,1747,9782,7572,9953,7752,1509,3917,3640,6322,768,8837,5865,3247,1549,6519,3436,7784,7751,980,587,6434,7746,9774,2888,179], function() { return __webpack_exec__(66667); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);